import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppModuleGlobalShared } from '../../app.module.global';
import { AsyncInfoComponent } from './components/asyncInfo/asyncInfo.component';
import { AsyncInfoService } from './components/asyncInfo/asyncInfo.service';
import { AsyncInfoPopupComponent } from './components/asyncInfo/popup/asyncInfoPopup.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarNavCustomComponent } from './components/navmenu/custom/sidebarnavcustom.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { NavMenuService } from './components/navmenu/navmenu.service';
import { CodigoEppoNombreCientificoPopupComponent } from './components/popup/especies/codigoEppoNombreCientificoPopup.component';
import { CodigoEppoPopupComponent } from './components/popup/especies/codigoEppoPopup.component';
import { EspecieEppoPopupComponent } from './components/popup/especies/especieEppoPopup.component';
import { OrganismosNocivosPopupComponent } from './components/popup/organismosnocivos/organismosNocivosPopup.component';
import { MigracionUsuarioPopupComponent } from './components/popup/usuarios/migracionUsuarioPopup.component';
import { DocumentUploaderComponent } from './components/uploader/document-uploader.component';
import { DocumentUploaderService } from './components/uploader/document-uploader.service';
import { MaxLengthLimitToDirective, OnlyDecimalDirective, OnlyNumberDirective } from './directives/control.directives';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from './_infrastructure/classes/handlers/timeoutRequestHandler';
import { AuthService } from './_infrastructure/classes/services/auth.service';
import { ConfigurationService } from './_infrastructure/classes/services/configuration.service';
import { GlobalService } from './_infrastructure/classes/services/global.service';
import { HeaderModule, FooterModule, GridModule, NavModule, SidebarModule } from '@coreui/angular';
import { UnlocodePopupComponent } from './components/popup/unlocode/unlocodePopup.component';
import { AuthInterceptor } from './_infrastructure/classes/handlers/authHandler';
import { DocumentInterceptorService } from './_infrastructure/classes/handlers/documentInterceptor';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';
import { CalendarModule } from 'primeng/calendar';
import { EntidadAuditoraPopupComponent } from './components/popup/entidadesauditoras/entidadAuditoraPopup.component';
import { SolicitudService } from '../_importacion/solicitudes/datosbasicos/datosbasicos.service';
import { AlertaRechazoComponent } from './components/alertaRechazo/alertaRechazo.component';
import { AlertaRechazoService } from './components/alertaRechazo/alertaRechazo.service';
import { CampaniasService } from './_infrastructure/classes/services/campanias-global.service';
import { LoadingInterceptor } from './_infrastructure/classes/handlers/loadingInterceptor';
import { LoginClaveComponent } from './components/login-clave/login-clave.component';
import { LogoutClaveComponent } from './components/logout-clave/logout-clave.component';
import { CookiesService } from './_infrastructure/classes/services/cookies.service';
import { CsrfInterceptor } from './_infrastructure/classes/handlers/CsrfInterceptor';
import { ArrobaClaveService } from './_infrastructure/classes/services/arroba-clave.service';
import { BroadcastService } from './_infrastructure/classes/services/broadcast.service';
import { CookiesPopupComponent } from './components/cookiesPopup/cookiesPopup.component';
import { AlertaCheddComponent } from './components/alerta-chedd/alerta-chedd.component';
import { AlertaCheddService } from './components/alerta-chedd/alerta-chedd.service';
import { BROADCAST_SERVICE } from 'src/app/app.module';

@NgModule({
    declarations: [
        NavMenuComponent,
        BreadcrumbComponent,
        DocumentUploaderComponent,
        AsyncInfoComponent,
        HeaderComponent,
        FooterComponent,
        SidebarNavCustomComponent,
        UnlocodePopupComponent,
        MaxLengthLimitToDirective,
        OnlyNumberDirective,
        OnlyDecimalDirective,
        CodigoEppoPopupComponent,
        CodigoEppoNombreCientificoPopupComponent,
        EspecieEppoPopupComponent,
        OrganismosNocivosPopupComponent,
        EntidadAuditoraPopupComponent,
        AsyncInfoPopupComponent,
        MigracionUsuarioPopupComponent,
        DialogComponent,
        DateRangePickerComponent,
        AlertaRechazoComponent,
        LoginClaveComponent,
        LogoutClaveComponent,
        CookiesPopupComponent,
        AlertaCheddComponent,
    ],
    imports: [
        AppModuleGlobalShared,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        // PrimeNg
        CalendarModule,
        // CoreUI
        HeaderModule,
        FooterModule,
        SidebarModule,
        GridModule,
        NavModule,
    ],
    exports: [
        NavMenuComponent,
        BreadcrumbComponent,
        DocumentUploaderComponent,
        HeaderComponent,
        FooterComponent,
        SidebarNavCustomComponent,
        MaxLengthLimitToDirective,
        OnlyNumberDirective,
        OnlyDecimalDirective,
        CodigoEppoPopupComponent,
        AsyncInfoPopupComponent,
        CodigoEppoNombreCientificoPopupComponent,
        EspecieEppoPopupComponent,
        OrganismosNocivosPopupComponent,
        EntidadAuditoraPopupComponent,
        MigracionUsuarioPopupComponent,
        DialogComponent,
        UnlocodePopupComponent,
        DateRangePickerComponent,
        AlertaRechazoComponent,
        AlertaCheddComponent,
        LoginClaveComponent,
        LogoutClaveComponent,
        CookiesPopupComponent,
        // CoreUI
        HeaderModule,
        FooterModule,
        SidebarModule,
        GridModule,
        NavModule,
    ],
    providers: [
        GlobalService,
        CampaniasService,
        NavMenuService,
        DocumentUploaderService,
        AsyncInfoService,
        ConfigurationService,
        MessageService,
        SolicitudService,
        AlertaRechazoService,
        AlertaCheddService,
        AuthService,
        ArrobaClaveService,
        CookiesService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CsrfInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DocumentInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        {
            provide: DEFAULT_TIMEOUT,
            useValue: 90000, // minuto y medio de timeout
            // TODO: mock value: useValue: 9990000, // 2,7 horas
        },
    ],
})
export class CoreModule {}
